export default __webpack_public_path__ + "static/media/Old_Visa_Logo.e0ba8cf1.svg";